import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { createMRTColumnHelper } from "material-react-table";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MDAlert from "../../components/MDAlert";
import MDTypography from "../../components/MDTypography";
import { AuthContext } from "../../context";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";
import { tenant } from "../../tenant";
import showToast from "../../utils/toast";
import GenericForm from "../genericForm";
import GenericTable from "pages/genericTable";
import MDBox from "components/MDBox";

function EditSuppliers() {
	const authContext = useContext(AuthContext);
	const [activeTab, setActiveTab] = useState(0);
	const { id } = useParams();
	const navigate = useNavigate();
	const columnHelper = createMRTColumnHelper();

	const handleChange = (event, newValue) => {
		setActiveTab(newValue);
	};

	const [personalData, setPersonalData] = useState({}); // Dati personali da query
	const [aree, setAree] = useState([]);
	const [suppliersArea, setSuppliersArea] = useState([]);

	const handleSetNotification = (msg, severityType) => {
		showToast(msg, severityType);
	};

	function fetchPersonal() {
		apiService
			.get("/suppliers-management/", { supplier_id: id }, {})
			.then((data) => {
				console.log("data", data);
				setPersonalData({ ...data, id: id });
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #000735",
					"error"
				)
			);
	}

	function fetchAreaSuppliers() {
		apiService
			.get("/suppliers-area-management/", { id_supplier: id }, {})
			.then((data) => {
				setSuppliersArea({ areas: data, id_supplier: id });
			})
			.catch((error) =>
				handleSetNotification(
					"Errore durante il caricamento dei dati. Riprova più tardi se l'errore persiste contatti il supoorto tecnico indicato l'errore #003139835",
					"error"
				)
			);
	}

	useEffect(() => {
		apiService
			.get("/area-management/", {}, {})
			.then((data) => {
				if (data) setAree(data);
				console.log("aree", data);
			})
			.catch((error) => {
				console.log(error);
				handleSetNotification(
					"Qualcosa è andato storto durante il caricamento dei ruoli. Riprovare più tardi, se l'errore persiste contatti il supporto tecnico segnalando l'errore #009839",
					"error"
				);
			});

		fetchPersonal();
		fetchAreaSuppliers();
	}, []);

	const handleSavePersonalData = (data) => {
		//console.log('Salva Dati Personali:', data);
	};

	async function deleteResource(params, endpoint) {
		try {
			// Parametri opzionali per la richiesta DELETE
			const headers = {}; // Headers opzionali

			// Esegui la chiamata DELETE
			const response = await apiService.delete(endpoint, params, headers);

			// Se arriviamo qui, la chiamata è andata a buon fine
			console.log(`Risorsa con id ${id} eliminata con successo:`, response);

			// Puoi fare qualcosa con la risposta, se necessario
			return response;
		} catch (error) {
			// Gestisci eventuali errori
			console.error(`Errore durante l'eliminazione della risorsa con id ${id}:`, error.message);

			// Puoi gestire l'errore in modo specifico, ad esempio:
			if (error.message.includes("404")) {
				console.log(`La risorsa con id ${id} non è stata trovata`);
			} else if (error.message.includes("403")) {
				console.log(`Non hai i permessi per eliminare la risorsa con id ${id}`);
			}

			// Rilancia l'errore se vuoi che venga gestito a un livello superiore
			throw error;
		}
	}

	function handleDelete(id, endpoint, resource, errorCode, sezione) {
		deleteResource(id, endpoint)
			.then((result) => {
				handleSetNotification(`${resource} eliminato con successo`, "success");
				// if (sezione === "area-roles") {
				//	fetchAreaRoles();
				// } else if (sezione === "contacts") {
				//	fetchContacts();
				// }
			})
			.catch((error) => {
				// Gestisci l'errore se non è stato gestito nella funzione
				handleSetNotification(
					`Si è verificato un errore durante l'eliminazione del ${resource}. Riprova più tardi se l'errore persiste contatta il supporto tecnico indicato l'errore #${errorCode}`,
					"error"
				);
			});
	}

	const handleDeleteRow = (id_row, sezione) => {
		if (sezione === "area-roles") {
			handleDelete(
				{ id_area: id_row, id_user: id, internal: false },
				"/user-management/area-roles/",
				"area",
				"000345",
				sezione
			);
		} else if (sezione === "contacts") {
			handleDelete(
				{ id_contact: id_row, id_user: id, internal: false },
				"/user-management/contacts/",
				"contact",
				"000346",
				sezione
			);
		}
	};

	const userTabColumns = [
		columnHelper.accessor("name", {
			header: "Nome",
			size: 120,
		}),
	];
	return (
		<DashboardLayout>
			{authContext.hasAuth("EDIT_SUPPLIERS") ? (
				<>
					<DashboardNavbar />
					<Box sx={{ width: "100%" }}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => navigate("/suppliers-managment")}
							sx={{
								mt: 2,
								alignSelf: "center",
								minWidth: "100px",
								color: "#ffffff",
								marginBottom: "30px",
							}}
						>
							Torna alla tabella fornitori
						</Button>
						<Tabs value={activeTab} onChange={handleChange} centered>
							<Tab label="Dati personali" />
							<Tab label="Dipendenti" />
							<Tab label="Cantieri associati" />
						</Tabs>

						<TabPanel value={activeTab} index={0}>
							<GenericForm
								authModelName={"SUPPLIERS"}
								old_data={personalData}
								url="/suppliers-management/"
								useAPI={true} // cambia a true per usare l'API
								executeOnSuccess={true}
								executeOnSuccessTask={fetchPersonal}
								requiredFields={[
									{ name: "name", nameDiplayed: "Nome" },
									{
										name: "fiscal_code",
										nameDiplayed: "P.IVA",
									},
								]}
								inputFields={[
									{
										type: "text",
										name: "name", // Nome nel DB
										label: "Nome fornitore", // Etichetta visibile
									},
									{
										type: "text",
										name: "fiscal_code", // Nome nel DB
										label: "P.IVA", // Etichetta visibile
									},
								]}
							/>
						</TabPanel>

						<TabPanel value={activeTab} index={2}>
							<GenericForm
								authModelName={"SUPPLIERS"}
								old_data={suppliersArea}
								url="/suppliers-area-management/"
								useAPI={true} // cambia a true per usare l'API
								extraData={{ id_supplier: id }}
								executeOnSuccess={true}
								executeOnSuccessTask={fetchAreaSuppliers}
								notChangeId={true}
								requiredFields={[{ name: "areas", nameDisplayed: "Aree" }]}
								inputFields={[
									{
										type: "autocomplete",
										name: "areas",
										label: "Cantieri",
										multiple: true,
										options: aree,
										valueToDisplay: (value, options) => {
											// Controlla se `value` è un oggetto
											if (typeof value === "object") {
												return `${value.name}`; // Mostra direttamente le informazioni
											}
											// Se `value` è un ID (numero)
											const option = options.find((opt) => opt.id === value); // Cerca l'opzione in base all'ID
											return option ? `${option.name}` : "auth non trovata"; // Messaggio se non trovato
										},
										valueToSave: (selected) => {
											// Se `selected` è un array
											if (Array.isArray(selected)) {
												// Crea un insieme di ID esistenti per evitare duplicati
												const existingIds = new Set(
													selected.map((opt) => (typeof opt === "object" ? opt.id : opt))
												);

												// Aggiungi il nuovo ID solo se non è già presente
												return Array.from(existingIds);
											}

											// Se `selected` è un singolo oggetto, restituisci il suo ID
											return selected?.id;
										},
										valueComparator: (option, value) => {
											// Controlla se `value` è un numero (ID)
											if (typeof value === "number") {
												return option.id === value; // Confronta l'ID dell'opzione con il valore
											}

											// Se `value` è un oggetto, confronta l'ID
											return option.id === value.id; // Confronta l'ID dell'opzione con l'ID dell'oggetto value
										},
									},
								]}
							/>
						</TabPanel>

						<TabPanel value={activeTab} index={1}>
							{Array.isArray(personalData.suppliers) && personalData.suppliers.length > 0 ? (
								<MDBox
									sx={{
										backgroundColor: "#F5F5F5",
									}}
								>
									<GenericTable
										authModelName={"INTERNAL_USER"}
										data={personalData.suppliers}
										columns={userTabColumns}
										onEdit={() => navigate(`/users-external-managment/edit/${id}`)}
									/>
								</MDBox>
							) : (
								<Typography variant="body2">Nessun cliente associato.</Typography>
							)}
						</TabPanel>
					</Box>
				</>
			) : (
				<MDAlert color="error" dismissible>
					<MDTypography variant="body2">You don't have permission to access this page</MDTypography>
				</MDAlert>
			)}
		</DashboardLayout>
	);
}

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`tabpanel-${index}`}
			aria-labelledby={`tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3 }}>
					<Typography component="div">{children}</Typography>
				</Box>
			)}
		</div>
	);
}

export default EditSuppliers;
